module.exports = __webpack_public_path__ + "img/hand-file.16882feb.png";